__turbopack_context__.v({
  "chevronIconWrapper": "testimonialsmasonrygroup-module-scss-module___Yi3Ea__chevronIconWrapper",
  "groupWrapper": "testimonialsmasonrygroup-module-scss-module___Yi3Ea__groupWrapper",
  "item": "testimonialsmasonrygroup-module-scss-module___Yi3Ea__item",
  "mobileExpanded": "testimonialsmasonrygroup-module-scss-module___Yi3Ea__mobileExpanded",
  "showMoreButtonContents": "testimonialsmasonrygroup-module-scss-module___Yi3Ea__showMoreButtonContents",
  "showMoreButtonWrapper": "testimonialsmasonrygroup-module-scss-module___Yi3Ea__showMoreButtonWrapper",
});
